import React from "react";
import type { ComplianceToastState } from "../hooks/useComplianceToast";

interface ComplianceToastProps {
  toast: ComplianceToastState;
}

export default function ComplianceToast({ toast }: ComplianceToastProps) {
  if (!toast) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: "18px",
        right: "18px",
        zIndex: 10000,
        minWidth: "280px",
        maxWidth: "460px",
        padding: "12px 14px",
        borderRadius: "10px",
        border:
          toast.type === "success"
            ? "1px solid rgba(16, 185, 129, 0.35)"
            : toast.type === "error"
              ? "1px solid rgba(239, 68, 68, 0.45)"
              : "1px solid rgba(96, 165, 250, 0.45)",
        background:
          toast.type === "success"
            ? "rgba(16, 185, 129, 0.16)"
            : toast.type === "error"
              ? "rgba(239, 68, 68, 0.16)"
              : "rgba(59, 130, 246, 0.16)",
        color:
          toast.type === "success"
            ? "#d1fae5"
            : toast.type === "error"
              ? "#fecaca"
              : "#bfdbfe",
        fontSize: "13px",
        fontWeight: 600,
        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.35)",
        backdropFilter: "blur(8px)",
      }}
    >
      {toast.message}
    </div>
  );
}
